import { Font } from '@react-pdf/renderer';

// 可用字体配置（仅保留实际用到的字体）
export const AVAILABLE_FONTS = {
  'SourceHanSansSC': {
    name: 'Source_Han_Sans_SC',
    family: 'Source_Han_Sans_SC',
    styles: {
      normal: {
        src: 'fonts/Source_Han_Sans_SC_Regular.otf',
        weight: 'normal',
        style: 'normal'
      },
      bold: {
        src: 'fonts/Source_Han_Sans_SC_Bold.otf',
        weight: 'bold',
        style: 'normal'
      }
    }
  },
  'NotoSerif': {
    name: '音标专用',
    family: 'NotoSerif',
    styles: {
      normal: {
        src: 'fonts/NotoSerif.ttf',
        weight: 'normal',
        style: 'normal'
      },
    }
  },
  'SystemDefault': {
    name: '系统默认',
    family: 'Helvetica',
    styles: {
      normal: {
        src: null,
        weight: 'normal',
        style: 'normal'
      }
    }
  }
};

// 字体注册状态
let registeredFonts = new Set();

// 全局字体配置
let globalFontConfig = {
  defaultFont: 'SourceHanSansSC',
  headerFont: 'SourceHanSansSC',
  contentFont: 'SourceHanSansSC'
};

// 注册单个字体族（支持多种样式）
const registerSingleFont = (fontConfig) => {
  if (!fontConfig.styles) return false;
  if (registeredFonts.has(fontConfig.family)) return true;
  let successCount = 0;
  for (const styleConfig of Object.values(fontConfig.styles)) {
    if (!styleConfig.src) continue; // 系统字体无需注册
    try {
      // 注意：实际的字体注册现在由FontLoader组件管理
      // 这里保留这个方法是为了向后兼容
      successCount++;
    } catch (e) {
      // 忽略注册失败
    }
  }
  if (successCount > 0) registeredFonts.add(fontConfig.family);
  return successCount > 0;
};

// 注册所有字体（应用启动时调用）
const registerAllFonts = () => {
  // 注意：实际的字体注册现在由FontLoader组件管理
  // 这里保留这个方法是为了向后兼容
  Object.values(AVAILABLE_FONTS).forEach(font => {
    if (font.family) {
      registeredFonts.add(font.family);
    }
  });
};

// 获取字体family（默认 Helvetica）
export const getFontFamily = (fontKey) => {
  const fontConfig = AVAILABLE_FONTS[fontKey];
  return fontConfig ? fontConfig.family : 'Helvetica';
};

// 获取全局默认字体family（兼容旧用法）
export const getSimpleFontFamily = () => {
  return getFontFamily(globalFontConfig.defaultFont);
};

// 设置全局字体
export const setGlobalFont = (fontKey) => {
  if (AVAILABLE_FONTS[fontKey]) {
    globalFontConfig.defaultFont = fontKey;
    globalFontConfig.headerFont = fontKey;
    globalFontConfig.contentFont = fontKey;
  }
};

// 标记字体为已注册
export const markFontAsRegistered = (fontFamily) => {
  registeredFonts.add(fontFamily);
};

// 检查字体是否已注册
export const isFontRegistered = (fontFamily) => {
  return registeredFonts.has(fontFamily);
};

// 启动时注册字体
registerAllFonts();

// 默认导出（兼容旧用法）
export default registerAllFonts;
